export { default as MoreProductIcon } from './more_product.svg';
